import React from "react";
import { Row, Col, Card } from "antd";
import "./index.css";
import coverProfile from "../../assets/images/login-bg.jpg";
import profile from "../../assets/images/rider.png";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";

import { MdModeEditOutline } from "react-icons/all";
const CoverImage = ({
  userImage,
  CoverImage,
  onChangeCoverImage,
  onChangeProfileImage,
  keyTab,
  onChangeBusinessImage,
  isShowEditCoverImage,
  isShowProfileIcon,
  isShowProfileName,
}) => {
  let profileImageRef;
  let coverImageRef;
  console.log("user_image==>", userImage);

  return (
    <Row justify="center">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        style={{ marginBottom: "10px" }}
      >

        <Row>
          {!isShowEditCoverImage && (
            <Row justify="end" align="middle" style={{ position: 'absolute', right: "0", zIndex: '1' }}>
              <Col
                style={{
                  padding: "1rem",
                  background: 'rgba(0, 0, 0, 0.26)',
                }}
              >
                <span className="color-white text-right">
                  Edit Store Cover Image
                </span>
                <span
                  className="pointer-cursor"
                  onClick={() => coverImageRef.click()}
                >
                  <Fab
                    color="primary"
                    aria-label="edit"
                    sx={{
                      "&.MuiFab-primary": { background: "#26a69a" },
                    }}
                    size="small"
                  >
                    <EditIcon />
                  </Fab>
                </span>
              </Col>
            </Row>
          )}
          <Col
            span={24}
            className="st-profile-cover"
            style={{
              backgroundImage: `url(${CoverImage})`,
            }}
          >

            <Row>
              <Col
                xl={4}
                lg={4}
                md={4}
                xs={18}
                sm={18}
                className="st-profile-img-container"
              >
                <Row>
                  <Col
                    xl={24}
                    lg={24}
                    className="st-circle-profile-image"
                    id="preview-logo"
                    style={{
                      backgroundImage: `url(${keyTab == 2
                        ? userImage?.rmx_company_asset.logo?.original
                        : userImage?.image?.original
                        })`,
                    }}
                  >
                    {!isShowProfileIcon && (
                      <Row justify="end">
                        <Col
                          className="pointer-cursor"
                          onClick={() => profileImageRef.click()}
                        >
                          <Fab
                            color="primary"
                            aria-label="edit"
                            sx={{
                              "&.MuiFab-primary": { background: "#26a69a" },
                            }}
                            size="small"
                          >
                            <EditIcon />
                          </Fab>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col
                xl={20}
                xxl={20}
                lg={20}
                md={20}
                sm={20}
                xs={20}
                style={{
                  height: "40vh",
                  position: "relative",
                }}
              >
                <Row
                  align="bottom"
                  justify="start"
                  className="st-profile-name-container">
                  <Col
                    xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}
                    className={keyTab == "2" ? "plant-profile-keyTab2  white-text text-left" : "plant-profile-keyTab1   white-text text-left"}
                  >
                    {!isShowProfileName && (
                      <h4 id="profile-name">
                        {keyTab == "2" ? `Welcome to ${userImage?.business_name}` : ` Hello, ${userImage?.first_name} ${userImage?.last_name}!`}
                      </h4>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <input
        type="file"
        ref={(ref) => (profileImageRef = ref)}
        className="d-none"
        onChange={(e) => {
          keyTab == "2" ? onChangeBusinessImage(e) : onChangeProfileImage(e);
        }}
      />
      <input
        type="file"
        ref={(ref) => (coverImageRef = ref)}
        className="d-none"
        onChange={(e) => {
          onChangeCoverImage(e, userImage);
        }}
      />
    </Row>
  );
};
export default CoverImage;
